<template>
  <div id="intro">
    <v-parallax
      v-if="this.$vuetify.breakpoint.mdAndUp"
      dark
      src="@/assets/back.jpg"
      height="980"
    >
      <v-container fill-height>
        <div id="particles-js"></div>
        <v-row style="height:100%;margin-left: 64px;">
          <v-spacer />
          <v-col cols="5" class="d-flex flex-column"
            ><v-spacer />
            <!-- <transition name="_slide_name"> -->
            <!-- class="noselect" -->
            <h1
              id="name"
              style="pointer-events: none;"
              data-aos="fade-left"
              data-aos-duration="1000"
            >
              Saikiran<br />Reddy
            </h1>
            <!-- </transition> -->
            <!-- <transition name="_slide_rect"> -->

            <!-- </transition> -->
            <v-spacer />
            <v-row>
              <!-- <transition name="_slide_li"> -->
              <v-btn
                icon
                x-large
                color="white"
                href="https://www.linkedin.com/in/saikiran-reddy/"
                target="_blank"
                data-aos="fade-left"
                data-aos-duration="1000"
                ><v-icon>mdi-linkedin</v-icon></v-btn
              >
              <!-- </transition> -->

              <!-- <transition name="_slide_gi"> -->
              <v-btn
                icon
                x-large
                color="white"
                href="https://github.com/kingavatar"
                target="_blank"
                data-aos="fade-left"
                data-aos-duration="1000"
                ><v-icon>mdi-github</v-icon></v-btn
              >
              <!-- </transition> -->
              <!-- <transition name="_slide_em"> -->
              <v-btn
                icon
                x-large
                color="white"
                href="mailto:saikiran.reddy@iiitb.org"
                data-aos="fade-left"
                data-aos-duration="1000"
                ><v-icon>mdi-email</v-icon></v-btn
              >
              <!-- </transition> -->
            </v-row>
            <v-spacer v-if="this.$vuetify.breakpoint.lgAndDown" />
          </v-col>
          <v-spacer v-if="this.$vuetify.breakpoint.lgAndDown" />
          <v-col
            cols="6"
            class="d-flex flex-column align-center justify-center"
          >
            <v-spacer />
            <v-row>
              <!-- <v-col class="mt-n3 mb-3 d-flex flex-column align-center"> -->
              <v-btn
                id="intobtn"
                text
                style="height: 60px;"
                data-aos="fade-right"
                data-aos-duration="1000"
                :color="introcol"
                @click="$vuetify.goTo('#intro', options(800, 'easeInQuad', 0))"
                >Intro</v-btn
              >
              <!-- </v-col> -->
              <v-btn
                id="aboutbtn"
                text
                style="height: 60px;"
                data-aos="fade-right"
                data-aos-duration="1000"
                :color="aboutcol"
                @click="$vuetify.goTo('#about', options(800, 'easeInQuad', 65))"
                >About</v-btn
              >
              <!-- <span class="dot"></span> -->
              <v-btn
                id="projectbtn"
                text
                style="height: 60px;"
                data-aos="fade-right"
                data-aos-duration="1000"
                :color="projcol"
                @click="
                  $vuetify.goTo('#projects', options(800, 'easeInQuad', 0))
                "
                >Projects</v-btn
              >
              <v-btn
                id="skillbtn"
                text
                style="height: 60px; "
                data-aos="fade-right"
                data-aos-duration="1000"
                :color="skillscol"
                @click="$vuetify.goTo('#skills', options(800, 'easeInQuad', 0))"
                >Skills</v-btn
              >
              <v-btn
                id="skillbtn"
                text
                style="height: 60px; "
                data-aos="fade-right"
                data-aos-duration="1000"
                :color="skillscol"
                @click="
                  $vuetify.goTo('#contact', options(1200, 'easeInQuad', 0))
                "
                >Contact</v-btn
              >
            </v-row>
            <v-col>
              <p
                class="introp"
                style="pointer-events: none;"
                data-aos="fade-left"
                data-aos-duration="1000"
              >
                Computer Science Student
              </p>
              <p
                class="introp"
                style="pointer-events: none;"
                data-aos="fade-left"
                data-aos-duration="1000"
              >
                IIIT Bangalore
              </p>
            </v-col>
            <v-spacer />
            <v-spacer />
            <v-col>
              <v-btn
                id="resumebtn"
                outlined
                color="#FBC02D"
                href="/saikiranResume.pdf"
                target="_blank"
                data-aos="fade-left"
                data-aos-duration="1000"
                ><v-icon left>mdi-download</v-icon> Resume</v-btn
              >
            </v-col>
            <!-- <v-spacer /> -->
            <v-spacer />
            <v-spacer />
          </v-col>
        </v-row>
      </v-container>
    </v-parallax>
    <v-parallax v-else dark src="@/assets/back_mobile.jpg" height="800">
      <v-container fill-height>
        <div id="particles-js"></div>
        <v-row justify="center">
          <h1
            id="name"
            style="pointer-events: none;"
            data-aos="fade-left"
            data-aos-duration="1000"
          >
            Saikiran<br />Reddy
          </h1>
        </v-row>
        <v-row justify="center">
          <p
            class="introp"
            style="pointer-events: none;"
            data-aos="fade-left"
            data-aos-duration="1000"
          >
            Computer Science<br />
            Student
          </p>
        </v-row>
        <v-row justify="center">
          <p
            class="introp"
            style="pointer-events: none;"
            data-aos="fade-left"
            data-aos-duration="1000"
          >
            IIIT Bangalore
          </p>
        </v-row>
        <v-row justify="center">
          <v-btn
            id="resumebtn"
            outlined
            color="#FBC02D"
            href="/saikiranResume.pdf"
            target="_blank"
            data-aos="fade-left"
            data-aos-duration="1000"
            ><v-icon left>mdi-download</v-icon> Resume</v-btn
          >
        </v-row>
        <v-row justify="center">
          <v-btn
            icon
            x-large
            color="white"
            href="https://www.linkedin.com/in/saikiran-reddy/"
            target="_blank"
            data-aos="fade-left"
            data-aos-duration="1000"
            ><v-icon>mdi-linkedin</v-icon></v-btn
          >
          <v-btn
            icon
            x-large
            color="white"
            href="https://github.com/kingavatar"
            target="_blank"
            data-aos="fade-left"
            data-aos-duration="1000"
            ><v-icon>mdi-github</v-icon></v-btn
          >
          <v-btn
            icon
            x-large
            color="white"
            href="mailto:saikiran.reddy@iiitb.org"
            data-aos="fade-left"
            data-aos-duration="1000"
            ><v-icon>mdi-email</v-icon></v-btn
          >
        </v-row>
      </v-container>
    </v-parallax>
  </div>
</template>
<script>
import "particles.js";
export default {
  name: "Intro",
  data: () => ({
    activeBtn: 0,
    introcol: "#ffffff",
    aboutcol: "#666874",
    projcol: "#666874",
    skillscol: "#666874"
    // slideTran: false
  }),
  methods: {
    options(du, eas, off) {
      return { duration: du, easing: eas, offset: off };
    },
    initParticles() {
      /* eslint-disable */
      particlesJS("particles-js", {
  "particles": {
    "number": {
      "value": 80,
      "density": {
        "enable": true,
        "value_area": 800
      }
    },
    "color": {
      "value": "#ffffff"
    },
    "shape": {
      "type": "circle",
      "stroke": {
        "width": 0,
        "color": "#000000"
      },
      "polygon": {
        "nb_sides": 5
      },
      "image": {
        "src": "img/github.svg",
        "width": 100,
        "height": 100
      }
    },
    "opacity": {
      "value": 0.5,
      "random": false,
      "anim": {
        "enable": false,
        "speed": 1,
        "opacity_min": 0.1,
        "sync": false
      }
    },
    "size": {
      "value": 3,
      "random": true,
      "anim": {
        "enable": false,
        "speed": 40,
        "size_min": 0.1,
        "sync": false
      }
    },
    "line_linked": {
      "enable": true,
      "distance": 150,
      "color": "#ffffff",
      "opacity": 0.4,
      "width": 1
    },
    "move": {
      "enable": true,
      "speed": 6,
      "direction": "none",
      "random": false,
      "straight": false,
      "out_mode": "out",
      "bounce": false,
      "attract": {
        "enable": false,
        "rotateX": 600,
        "rotateY": 1200
      }
    }
  },
  "interactivity": {
    "detect_on": "canvas",
    "events": {
      "onhover": {
        "enable": true,
        "mode": "repulse"
      },
      "onclick": {
        "enable": true,
        "mode": "push"
      },
      "resize": true
    },
    "modes": {
      "grab": {
        "distance": 400,
        "line_linked": {
          "opacity": 1
        }
      },
      "bubble": {
        "distance": 400,
        "size": 40,
        "duration": 2,
        "opacity": 8,
        "speed": 3
      },
      "repulse": {
        "distance": 200,
        "duration": 0.4
      },
      "push": {
        "particles_nb": 4
      },
      "remove": {
        "particles_nb": 2
      }
    }
  },
  "retina_detect": true
});
    }
  },
  created() {},
  mounted() {
    // this.slideTran = true;
    // console.log(this.$vuetify.breakpoint.name);
    // this.$nextTick(() => {
      this.initParticles();
    // });
  }
};
</script>
<style scoped>
#intro {
  background-color: #252734;
  width: 100%;
  height: 1065px;
}
#particles-js {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
    left: 0;
}
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}
.container {
   position: relative;
  /* margin-left: 64px; */
  padding-right: 64px;
  margin-right: 0px;
  max-width: 100%;
}
h1 {
  color: #ebebec;
  margin: 0;
  font-family: "Gilroy Bold";
}
#name {
  font-size: 7.5rem;
}

.introp {
  font-size: 40px;
  /* font-weight: 500; */
  font-family: "Gilroy Medium";
}

#resumebtn.v-btn {
  height: 48px;
  font-weight: 500;
  text-transform: none;
  letter-spacing: normal;
  font-family: "Gilroy Medium";
}

#resumebtn.v-btn.v-size--default {
  /* font-size: 4rem; */
  font-size: 2rem;
}
.v-btn {
  font-weight: 500;
  text-transform: none;
  letter-spacing: normal;
  font-family: "Gilroy SemiBold";
}
.v-btn.v-size--default {
  /* font-size: 4rem; */
  font-size: 2.5rem;
}

/* ._slide_name-enter-active,
._slide_li-enter-active,
._slide_gi-enter-active,
._slide_em-enter-active,
._slide_rect-enter-active {
  transition: all 0.75s ease;
}
._slide_name-enter {
  transform: translateX(60px);
  opacity: 0;
}
._slide_rect-enter {
  transform: translateX(80px);
  opacity: 0;
}
._slide_li-enter {
  transform: translateX(120px);
  opacity: 0;
}
._slide_gi-enter {
  transform: translateX(160px);
  opacity: 0;
}
._slide_em-enter {
  transform: translateX(200px);
  opacity: 0;
} */
</style>

<style lang="scss" scoped>
@import "~vuetify/src/styles/styles.sass";
@media #{map-get(
    $display-breakpoints,
    "md-and-down"
  )} {
  #intro {
    width: 100%;
    height: 845px;
  }
  #name {
    font-size: 4rem;
  }
  .introp {
    font-size: 30px;
  }
  .container {
    margin: 0;
    padding: 12px;
    max-width: 100%;
  }
}
@font-face {
  font-family: "Gilroy Bold";
  src: url("../assets/fonts/Gilroy-Bold.eot");
  src: url("../assets/fonts/Gilroy-Bold.eot?#iefix") format("embedded-opentype"),
    url("../assets/fonts/Gilroy-Bold.woff") format("woff"),
    url("../assets/fonts/Gilroy-Bold.otf") format("opentype"),
    url("../assets/fonts/Gilroy-Bold.ttf") format("truetype"),
    url("../assets/fonts/Gilroy-Bold.svg") format("svg");
}
@font-face {
  font-family: "Gilroy SemiBold";
  src: url("../assets/fonts/Gilroy-SemiBold.eot");
  src: url("../assets/fonts/Gilroy-SemiBold.eot?#iefix")
      format("embedded-opentype"),
    url("../assets/fonts/Gilroy-SemiBold.woff") format("woff"),
    url("../assets/fonts/Gilroy-SemiBold.otf") format("opentype");
}
@font-face {
  font-family: "Gilroy Medium";
  src: url("../assets/fonts/Gilroy-Medium.eot");
  src: url("../assets/fonts/Gilroy-Medium.eot?#iefix")
      format("embedded-opentype"),
    url("../assets/fonts/Gilroy-Medium.woff") format("woff"),
    url("../assets/fonts/Gilroy-Medium.otf") format("opentype");
}
@font-face {
  font-family: "Gilroy Regular";
  src: url("../assets/fonts/Gilroy-Regular.eot");
  src: url("../assets/fonts/Gilroy-Regular.eot?#iefix")
      format("embedded-opentype"),
    url("../assets/fonts/Gilroy-Regular.woff") format("woff"),
    url("../assets/fonts/Gilroy-Regular.otf") format("opentype");
}
</style>
